/*
  Sentopia — corrige las ETIQUETAS DUPLICADAS de las tarjetas de producto.

  Problema (del tema, no de los datos): en labels-and-badges.js, initAllLabels()
  borra las etiquetas existentes de forma SINCRONA pero las vuelve a pintar dentro
  de un requestAnimationFrame, y appendLabel() inserta con `innerHTML +=` (anade,
  nunca reemplaza). Ademas load() registra el listener `eurus:<seccion>:splide-ready`
  SIN {once:true} y libera su guarda `loadingEl` de inmediato.
  Resultado: si el render corre dos veces seguidas (p.ej. al cambiar de pestana en el
  carrusel "Los mas Destacados", que vuelve a emitir splide-ready), ambas pasadas
  limpian cuando todavia no hay nada pintado y despues cada una anade su copia ->
  "NUEVO NUEVO", "AGOTADO AGOTADO".

  Arreglo: se envuelve appendLabel para que, antes de anadir una etiqueta, elimine
  cualquier copia previa de ESA MISMA etiqueta dentro de la misma tarjeta. Asi pintar
  dos veces da el mismo resultado que pintar una vez (idempotente), sin tocar el
  motor original ni cambiar que etiquetas se muestran.

  Se excluyen las posiciones que el tema duplica A PROPOSITO (below-image, bottom-card,
  next-price copian su HTML a otros contenedores mediante outSideImageTemplate) y la
  ficha de producto (container 'product-info', que no vive dentro de .card-product).
*/
(function () {
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (tries > 200) { clearInterval(timer); return; }   // ~10 s como maximo
    try {
      if (!(window.Alpine && Alpine.store && Alpine.store('xBadges'))) return;
      var store = Alpine.store('xBadges');
      if (store.__sentopiaDedupe || typeof store.appendLabel !== 'function') {
        clearInterval(timer);
        return;
      }
      store.__sentopiaDedupe = true;
      var original = store.appendLabel.bind(store);

      store.appendLabel = function (el, label, productData) {
        try {
          var position = label && label.settings && label.settings.position;
          var duplicadaAProposito =
            position === 'below-image' || position === 'bottom-card' || position === 'next-price';

          if (!duplicadaAProposito && label && label.id && el && el.closest) {
            var card = el.closest('.card-product');
            if (card) {
              var previas = card.getElementsByClassName('x-badge-' + label.id);
              while (previas.length > 0) previas[0].remove();
            }
          }
        } catch (e) {
          /* ante cualquier duda, no tocar nada y dejar pintar el motor original */
        }
        return original(el, label, productData);
      };

      clearInterval(timer);
    } catch (e) {
      clearInterval(timer);
    }
  }, 50);
})();
